import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-subtitle-2 mb-2 d-block" }
const _hoisted_2 = {
  "aria-live": "polite",
  style: {"font-weight":"bold"}
}
const _hoisted_3 = ["for"]
const _hoisted_4 = ["id", "value"]
const _hoisted_5 = { class: "ml-1" }

import { computed } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'YearsPicker',
  props: /*@__PURE__*/_mergeModels({
    possibleYears: {},
    showErrorForEmpty: { type: Boolean }
  }, {
    "modelValue": {
  type: Array as () => number[]
},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {



const selectedYears = _useModel<number[]>(__props, "modelValue");

const empty = computed(() => selectedYears.value?.length === 0);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({'dtrs-error-highlight': __props.showErrorForEmpty && empty.value, 'dtrs-years-picker': true})
  }, [
    _createElementVNode("label", _hoisted_1, [
      _cache[1] || (_cache[1] = _createTextVNode("Years ", -1)),
      _withDirectives(_createElementVNode("span", _hoisted_2, " (Select at least 1) ", 512), [
        [_vShow, __props.showErrorForEmpty && empty.value]
      ])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.possibleYears, (year) => {
      return (_openBlock(), _createElementBlock("div", {
        key: year,
        class: "d-inline-block"
      }, [
        _createElementVNode("label", {
          class: "mr-3",
          style: {"text-wrap":"nowrap"},
          for: `dtrs-year-${year}`
        }, [
          _withDirectives(_createElementVNode("input", {
            id: `dtrs-year-${year}`,
            type: "checkbox",
            value: year,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedYears).value = $event))
          }, null, 8, _hoisted_4), [
            [_vModelCheckbox, selectedYears.value]
          ]),
          _createElementVNode("span", _hoisted_5, _toDisplayString(year), 1)
        ], 8, _hoisted_3)
      ]))
    }), 128))
  ], 2))
}
}

})